/* eslint-disable */
import React from 'react';
import { Row, Col, Button, Input, Label } from 'reactstrap';
import { Modal } from 'antd';
import { AlertMessage } from '../AlertMessage/AlertMessage';
import { useTranslation } from 'react-i18next';

const DropDownModal = ({
  title = '',
  titleDarkSide = '',
  subText = 'Select reason to view the documents',
  noBtnHandler,
  yesBtnHandler,
  closeBtnHandler,
  dropdownValueChange,
  reasonList,
  showalertMessage,
  yesBtnText = 'Yes',
  noBtnText = 'No',
  btnsStyle = {},
  ...restProps
}) => {
  const { t } = useTranslation('common');

  return (
    <Modal
      {...restProps}
      centered
      keyboard={false}
      footer={null}
      onCancel={closeBtnHandler}
      closable={!!closeBtnHandler}
    >
      <div className="vl-common-timeline-bootstrap-overrides ">
        <div className="vl-common-bootstrap">
          <Row>
            <Col className="vl-flex-col-center">
              <div style={styles.title}>{title}</div>
              <AlertMessage message={showalertMessage.msg} visibility={showalertMessage.visibility} />
              <br />
              <div>
                <Label for="exampleSelect">{subText}</Label>
                <Input
                  type="select"
                  onChange={(event) => {
                    dropdownValueChange(event.target.value);
                  }}
                  name="select"
                  required
                >
                  <option value="">{t('Select')}</option>
                  {Object.keys(reasonList).map((item, key) => {
                    return (
                      <option value={reasonList[item].reason_code} key={reasonList[item].reason_code}>
                        {reasonList[item].reason_description}
                      </option>
                    );
                  })}
                </Input>
              </div>
              <br />
              <div className="vl-flex-row-center" style={styles.btnsContainer(subText)}>
                {noBtnText !== '' && (
                  <Button style={{ ...styles.btnGray, ...btnsStyle }} type="button" onClick={noBtnHandler}>
                    {noBtnText}
                  </Button>
                )}
                {yesBtnText !== '' && (
                  <Button style={{ ...styles.btnMain, ...btnsStyle }} type="button" onClick={yesBtnHandler}>
                    {yesBtnText}
                  </Button>
                )}
              </div>
            </Col>
          </Row>
        </div>
      </div>
    </Modal>
  );
};

export { DropDownModal };

const styles = {
  btnMain: {
    width: '110px',
    backgroundColor: 'var(--productPrimary)',
    fontSize: '14px',
    padding: '4px 10px',
    borderColor: 'var(--productPrimary)',
    color: 'var(--productPrimaryDark)'
  },
  btnGray: {
    width: '110px',
    backgroundColor: 'var(--productGray)',
    fontSize: '14px',
    padding: '4px 10px',
    borderColor: 'var(--productGray)',
    marginRight: '10px'
  },
  title: { color: 'var(--productPink)', fontSize: '30px', fontWeight: 'bold' },
  titleDarkSide: { color: 'var(--productPrimaryDark)', fontWeight: 'bold' },
  subText: {
    color: 'var(--productPrimaryDark)',
    fontSize: '14px',
    marginTop: '30px',
    marginBottom: '30px',
    textAlign: 'center'
  },
  btnsContainer: (subText) => ({
    marginBottom: '30px',
    marginTop: subText.trim() === '' ? '30px' : '5px'
  })
};

/* //Example
<ConfirmModal
  isOpen={modalEditDetailsCancel}
  toggle={toggleModalEditDetailsCancel}
  noBtnHandler={()=>{}}
  yesBtnHandler={()=>{}}
/>
*/
